import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseSubscriberChannelComponent } from '../../abstract-components/base-subscriber-channel.component';

@Component({
  selector: 'subscriber-channel-card',
  standalone: false,
  templateUrl: './subscriber-channel-card.component.html',
  styleUrl: './subscriber-channel-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubscriberChannelCardComponent extends BaseSubscriberChannelComponent {}
